import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { AdviserChargesContents } from "../Resource/Contents";

interface IChargesOnIllustrationProps extends IProcessComponentProps {}

interface IChargesOnIllustrationState {}

export class ChargesOnIllustration extends ProcessComponent<IChargesOnIllustrationProps, IChargesOnIllustrationState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        if (isNullOrEmpty(data?.ChargesExtraInfo?.ExcludeChargesOnIllustration)) {
            this.onDataChange(onChange, { ExcludeChargesOnIllustration: false }, data, "ChargesExtraInfo");
        }
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                <h3 className="heading-underlined mt-20">{AdviserChargesContents.ChargesOnIllustration}</h3>
                <RadiosEditor
                    cssWrapper="rg-150 mb-24"
                    label={"Do you want to exclude adviser charges from illustration?"}
                    selected={data?.ChargesExtraInfo?.ExcludeChargesOnIllustration}
                    options={[true, false]}
                    tooltip={AdviserChargesContents.ChargesOnIllustrationToolTip}
                    showTooltipCloseButton={true}
                    getText={(v) => (v ? "Yes" : "No")}
                    required={"Please select"}
                    onChange={(v) =>
                        this.onDataChange(onChange, { ExcludeChargesOnIllustration: v }, data, "ChargesExtraInfo")
                    }
                />
            </>
        );
    }
}
